import Counties from "../config/CountiesConfig";

export class BurnModelUtils {

    static colorIdToHex(colorId){
        if(colorId === "1"){
            return "#00e400"
        }
        else if (colorId == "2"){
            return "#ffff00"
        }
        else  if (colorId == "3"){
            return "#ff0000"
        }
        else{
            return "#e1e1e1"
        }
    }
    static colorIdToCategory(colorId){
        if(colorId === "1"){
            return "Small"
        }
        else if (colorId == "2"){
            return "Medium"
        }
        else  if (colorId == "3"){
            return "Large"
        }
        else{
            return "No Data Available"
        }
    }

     static matchCounty(dayCsv, county) {


        for (let i = 1; i < dayCsv.length; i++) {
            const row = dayCsv[i];

            if (row[0].trim() === county.name) {
                return row;
            }
        }

        // Business logic dictates Johnson county use Wyandotte county contributions
        if( county.name === "Johnson"){
            return this.matchCounty(dayCsv, Counties.find(county => county.name === "Wyandotte"));
        }

        return null;
    }

    static getCountyContributions(dayCsv) {

        return Counties.map(county => {
            const row = BurnModelUtils.matchCounty(dayCsv, county);

            if (row) {
                return {
                    ...county,
                    backgroundColor: BurnModelUtils.colorIdToHex(row[1].trim()),
                    contributionCategory: BurnModelUtils.colorIdToCategory(row[1].trim())
                };
            }

            return county;
        });
    }






}